module.exports = __webpack_public_path__ + "img/features_13.459396bb.png";